(ns ui.components.input.search
  (:require
   ["lucide-react" :refer [Search]]
   [ui.components.input.zapkit-styles :as zapkit-styles]
   [ui.dom-globals :as dg]
   [ui.util :as uu]))

;; The search icon must not intercept clicks meant for the input underneath.
;; Upstream positions its icons but never has to care, because it only renders
;; them alongside affixes that are themselves interactive.
(def icon-overrides
  {:start "tw2-pointer-events-none"})

(defn view
  [{:keys [value on-change placeholder disabled? class wrapper-class input-class icon-class]}]
  (let [styles zapkit-styles/input]
    [:div
     {:class (uu/cm (get-in styles [:input-container :base])
                    wrapper-class
                    class)}
     [:div
      {:class (uu/cm (get-in styles [:icon :start])
                     (:start icon-overrides))}
      [:> Search
       {:className (uu/cm "tw2-h-4 tw2-w-4 tw2-text-tertiary"
                          icon-class)
        :aria-hidden true}]]
     [:input
      {:type      "text"
       :class     (uu/cm (get-in styles [:base])
                         (get-in styles [:state (if disabled?
                                                  :disabled
                                                  :default)])
                         (get-in styles [:modifiers :with-start-icon])
                         input-class)
       :value     value
       :disabled  (boolean disabled?)
       :placeholder (or placeholder "Search")
       :on-change (fn [e]
                    (when (fn? on-change)
                      (on-change (dg/event-target-value e))))}]]))
